/** Caps short free-text fields, such as subjects, labels, and titles, in the interest context slice. */
export const ASSISTANT_INTEREST_TEXT_MAX_CHARACTERS = 200;
